import { useQuery } from '@tanstack/react-query';
import type {
  V3ApiSuccessfulResponse,
  V3ApiFailedResponse,
} from 'javascripts/services/v3ApiClient';
import { request } from 'javascripts/services/v3ApiClient';
import { PageObject } from 'data/v3/data-contracts';

export type GetProjectPageResponse = V3ApiSuccessfulResponse<PageObject>;

export const PROJECT_PAGE_QUERY_KEY = 'PageProject';

export const useGetProjectPage = ({
  pageDbId,
  projectDbId,
}: {
  pageDbId: PageObject['id'];
  projectDbId: number;
}) => {
  const { data, isLoading, error } = useQuery<
    GetProjectPageResponse,
    V3ApiFailedResponse
  >({
    queryFn: () => {
      return request({
        url: `projects/${projectDbId}/pages/${pageDbId}`,
      });
    },
    queryKey: [PROJECT_PAGE_QUERY_KEY, pageDbId],
  });

  return {
    page: data?.data,
    isLoading,
    error,
  };
};
